module.exports = __webpack_public_path__ + "static/media/vargur.91e34389.svg";